import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from '@/shared/components/Chip';
const TONO_ESTADO = {
    SOLICITADA: 'warning',
    CONFIRMADA: 'success',
    CANCELADA: 'danger',
    FINALIZADA: 'neutral',
};
export const LABEL_ESTADO_RESERVA = {
    SOLICITADA: 'Solicitada',
    CONFIRMADA: 'Confirmada',
    CANCELADA: 'Cancelada',
    FINALIZADA: 'Finalizada',
};
export function ChipEstadoReserva({ estado }) {
    return (_jsx(Chip, { tono: TONO_ESTADO[estado] ?? 'neutral', children: LABEL_ESTADO_RESERVA[estado] ?? estado }));
}
const TONO_TIPO = {
    PRIVADA: 'primary',
    GRUPAL: 'info',
    EMPRESA: 'neutral',
};
export const LABEL_TIPO_CLASE = {
    PRIVADA: 'Privada',
    GRUPAL: 'Grupal',
    EMPRESA: 'Empresa',
};
export function ChipTipoClase({ tipo }) {
    return (_jsx(Chip, { tono: TONO_TIPO[tipo] ?? 'neutral', children: LABEL_TIPO_CLASE[tipo] ?? tipo }));
}
